<div class="tw-relative tw-flex tw-h-full tw-flex-col tw-bg-teal-200"
  appKeyboardInset
  (keyboardOpenChange)="handleKeyboardOpenChange($event)">
  @if (showBack()) {
    <div class="tw-absolute tw-left-6 tw-top-16 tw-z-20 tw-h-6 tw-w-6"
      id="back-btn"
      role="button"
      (click)="handleBack()">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-800"
        [iconName]="'arrow_back'"></cs-icon>
    </div>
  }
  <div class="tw-flex-1"></div>
  <div class="tw-relative tw-flex tw-w-full tw-items-end tw-justify-between">
    <div class="tw-mb-8.5 tw-animate-onboarding_page_enter tw-pl-6 tw-font-lexend">
      <ng-content select="[shellEyebrow]"></ng-content>
      <ng-content select="[shellHeading]"></ng-content>
    </div>
    <div class="tw-relative tw-w-onboarding-doctor tw-shrink-0">
      <img class="tw-absolute -tw-bottom-10 -tw-right-3.5 tw-z-0 tw-w-full"
        src="/assets/images/dr-charu.png"
        alt="Dr Charu" />
    </div>
  </div>
  <div class="tw-z-10 tw-h-onboarding-sheet tw-overflow-y-auto tw-rounded-t-5 tw-bg-white tw-px-6 tw-pb-24 tw-pt-6">
    <div class="tw-animate-onboarding_page_enter">
      <ng-content></ng-content>
    </div>
  </div>
  @if (showFooter()) {
    <footer class="tw-fixed tw-bottom-keyboard-inset tw-left-0 tw-right-0 tw-z-20 tw-bg-white tw-px-6 tw-pt-3"
      [class.tw-pb-3]="isKeyboardOpen()"
      [class.tw-pb-8]="!isKeyboardOpen()">
      <ng-content select="[shellFooter]"></ng-content>
    </footer>
  }
</div>
